'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

var _colors = require('HubStyleTokens/colors');

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _color = require('MeetingsLib/utils/color');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FreemiumUpgradeButton',

  propTypes: {
    handleButtonClick: _react.PropTypes.func.isRequired,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired
  },

  getBrandingActiveStyle: function getBrandingActiveStyle() {
    var primaryColor = this.props.branding.primaryColor;


    if (!primaryColor) {
      return null;
    }

    return {
      width: 'auto',
      borderColor: primaryColor,
      backgroundColor: (0, _color.getColorStyleWithOpacity)(primaryColor)
    };
  },
  getBrandingTextStyle: function getBrandingTextStyle() {
    var primaryColor = this.props.branding.primaryColor;


    if (!primaryColor) {
      return null;
    }

    return { color: primaryColor };
  },
  render: function render() {
    var handleButtonClick = this.props.handleButtonClick;


    return _react2.default.createElement(
      _UISelectableBox2.default,
      {
        padded: false,
        selected: false,
        className: 'freemium-advert-button',
        style: this.getBrandingActiveStyle(),
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onClick: handleButtonClick
      },
      _react2.default.createElement(_UIIcon2.default, { name: icons.SPROCKET, color: _colors.LORAX, className: 'm-right-1' }),
      _react2.default.createElement(
        'span',
        { style: this.getBrandingTextStyle() },
        _react2.default.createElement(_I18nReact2.default, { message: 'summary.meetingsAdvert.freemium' })
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/freemium/FreemiumUpgradeButton.js
// module id = 494
// module chunks = 0